/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { BadgeMobility } from "../BadgeMobility";
import "./style.css";

export const CmpStretchbadge = ({ className }) => {
  return (
    <div className={`cmp-stretchbadge ${className}`}>
      <BadgeMobility
        className="badge-mobility-stretch"
        divClassName="badge-mobility-instance"
      />
    </div>
  );
};
